import { HomeRankingTabEnum } from "@enums";

export enum MenuGapsEnum {
    POPULARITY = 'popularity',
    TREND_GAP = 'trendGap'
}

export const MENU_SELECTED_IC_STORAGE_KEY = (categoryId: string) => `category-profile-menu-ic-${categoryId}`;
export const MENU_RANKING_STORAGE_KEY = 'category-profile-menu-ranking';
export const MENU_GAPS_STORAGE_KEY = 'category-profile-menu-gaps';

export const MENU_RANKING_TABS: { id: HomeRankingTabEnum; title: string }[] = [
    { id: HomeRankingTabEnum.WHATS_TOP, title: "What's Top" },
    { id: HomeRankingTabEnum.WHATS_GROWING, title: "What's Growing" },
];

export const MENU_GAPS_TABS: { id: MenuGapsEnum; title: string }[] = [
    { id: MenuGapsEnum.POPULARITY, title: "Popularity" },
    { id: MenuGapsEnum.TREND_GAP, title: "Trend Gap" },
];

